import { useState } from 'react';
import { ForgotPasswordProp } from '../userInvite.type';
import { ENDPOINT_CONSTANTS } from 'constant';

export type NewPasswordPayload = {
  password: string;
  registerNumber: string;
};

export type Invitation = {
  name: string;
  organization: string;
  role: string;
};

const useInviteUser = (token: string | null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [data, setData] = useState<Invitation | null>(null);

  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };

  const inviteUser = async (payload: ForgotPasswordProp) => {
    setIsLoading(true);
    setIsError(false);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${ENDPOINT_CONSTANTS.MY_INVITATION}`,
        {
          headers,
          method: 'POST',
          body: JSON.stringify(payload)
        }
      );
      if (response.status === 200) {
        setIsSuccess(true);
      } else {
        setIsError(true);
      }
    } catch (error) {
      console.log(error, 'error');
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const getInvitation = async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}${ENDPOINT_CONSTANTS.MY_INVITATION}`,
        {
          headers,
          method: 'GET'
        }
      );
      if (response.status === 200) {
        setIsSuccess(true);
        const responseData = await response.json();
        setData(responseData?.data);
      } else {
        setIsError(true);
      }
    } catch (error) {
      console.log(error, 'error');
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return { inviteUser, isLoading, isError, isSuccess, data, getInvitation };
};

export default useInviteUser;
